export default __webpack_public_path__ + "static/media/mobile.dc4b0074.png";